import axios from "axios";
import AwesomeDebouncePromise from "awesome-debounce-promise";

const searchAPI = async ({ query, url, parentId }) =>
  axios.get(`${url}?search=${query}`).then(({ data }) => data.data);

export const ajaxFindFunders = AwesomeDebouncePromise(searchAPI, 500);
